import {ActionLink} from 'shared/components';
import CloseIcon from 'img/close-icon-white@2x.png';

const PreviewBanner = ({colour, onHide, children}) => (
  <div className={`${colour} white flex items-center`} style={{padding: '0.6rem 0.6rem'}}>
    <div className='flex-auto center'>{children}</div>
    <ActionLink className='Link-icon align-middle' onClick={() => onHide()}>
      <img src={CloseIcon} className='img-hover' alt='close' width='14px'/>
    </ActionLink>
  </div>
);

PreviewBanner.defaultProps = {
  colour: 'bg-meadow'
};

export default PreviewBanner;
